import { render } from "./ProfileLayoutProfileBanner.vue?vue&type=template&id=5cfae3a1&scoped=true"
import script from "./ProfileLayoutProfileBanner.vue?vue&type=script&lang=js"
export * from "./ProfileLayoutProfileBanner.vue?vue&type=script&lang=js"

import "./ProfileLayoutProfileBanner.vue?vue&type=style&index=0&id=5cfae3a1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfae3a1"]])

export default __exports__